import { render, staticRenderFns } from "./EcPaginate.vue?vue&type=template&id=e209bf7a&"
import script from "./EcPaginate.vue?vue&type=script&lang=ts&"
export * from "./EcPaginate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports